import { render, staticRenderFns } from "./ModalStatusHistory.vue?vue&type=template&id=6c9e1f20&scoped=true&"
import script from "./ModalStatusHistory.vue?vue&type=script&lang=ts&"
export * from "./ModalStatusHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStatusHistory.vue?vue&type=style&index=0&id=6c9e1f20&prod&lang=scss&"
import style1 from "./ModalStatusHistory.vue?vue&type=style&index=1&id=6c9e1f20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9e1f20",
  null
  
)

export default component.exports